// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__2omCG","header":"ClearentDisclaimer_header__HzmPG","inner":"ClearentDisclaimer_inner__2S_y_"};